/**
 * Range maths for the assign popovers' start/end pickers.
 *
 * Kept apart from the component because this is the fiddly half: a user
 * correcting a finger-drawn highlight regularly drags one end past the other,
 * and the range that comes out still has to be something the grid can hold —
 * at least one slot, inside the shift.
 *
 * Slots are half-open [start, end): `end` is the boundary the range stops at,
 * so it runs 1…numSlots while `start` runs 0…numSlots-1.
 */

import { NUM_SLOTS } from "@/config/modeConfig";

/**
 * Settle a range after the user moved one of its ends.
 *
 * The end they did NOT touch gives way: moving the start past the end pushes
 * the end along, and vice versa. That keeps the picker they are looking at
 * showing exactly what they chose.
 */
export function clampSelectionSlots(
  startSlot: number,
  endSlot: number,
  moved: "start" | "end",
  numSlots: number = NUM_SLOTS,
): [number, number] {
  if (moved === "start") {
    const start = Math.min(Math.max(startSlot, 0), numSlots - 1);
    return [start, Math.min(Math.max(endSlot, start + 1), numSlots)];
  }
  const end = Math.min(Math.max(endSlot, 1), numSlots);
  return [Math.max(Math.min(startSlot, end - 1), 0), end];
}
